import type { ReactNode } from "react";

export const AvbestillDetaljerContainer = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  return (
    <div className="flex flex-col gap-8 bg-balder-background-tinted p-5 rounded-3xl border-neutral-border-subtle border-1">
      {children}
    </div>
  );
};
